<template>
  <div>
    <div
      v-for="(agentType, index) in agentTypes"
      :key="index"
      class="mb-4 card"
    >
      <div class="card-body" v-if="customer">
        <div class="row">
          <div class="col">
            <h4>{{ agentType.label | t }}</h4>
          </div>
        </div>
        <hr />
        <customer-agent-form
          :customer="customer"
          :agent_type="agentType.type"
        />
      </div>
    </div>
    <div
      class="mb-4 card"
      v-if="customer && customer.data_processing_agreement_accepted_version"
    >
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h4>{{ "data_processing_agreement_details" | t }}</h4>
          </div>
        </div>
        <hr />
        <div
          v-for="(value, key) in dataProcessingAgreementDetails"
          :key="key"
          class="mb-2 row"
        >
          <div class="col-md-4">
            <strong>{{ key | t | titlecase }}</strong>
          </div>
          <div class="col-md-8">{{ value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    agentTypes() {
      return [
        { label: "sales_agent", type: "sales_agent" },
        { label: "onboarding_agent", type: "onboarding_agent" },
        { label: "customer_success_agent", type: "customer_success_agent" },
      ];
    },
    dataProcessingAgreementDetails() {
      return {
        version: this.customer.data_processing_agreement_accepted_version,
        name: this.customer.data_processing_agreement_acceptor_name,
        phone: this.customer.data_processing_agreement_acceptor_phone,
        email: this.customer.data_processing_agreement_acceptor_email,
      };
    },
  },
};
</script>